<template>
  <div id="filter-token-component" class="filter-token relative inline-block mb-8 mb-24 mt-8">
    <button
      :id="modalLabel + '-filter-token-button'"
      :class="`filter-token-button` + selectedClass + ' ' + buttonClasses"
      @click.prevent="buttonHandler"
    >
      {{ buttonLabel }}
      <Caret class="ml-6" :class="iconDirection" />
    </button>
    <div
      v-if="buttonToggled"
      class="fixed z-[9998] top-0 left-0 w-full h-full table text-subtitle"
      :class="
        mobileFiltersOnLargerScreens
          ? 'desktop-styles--container'
          : 'sm:inline-block sm:absolute sm:bg-opacity-0 sm:top-[calc(100%+12px)] sm:w-368 sm:h-auto sm:margin-0 sm:bg-none'
      "
      @touchstart="closeModal"
    >
      <div class="inline-block w-full" @mousedown.prevent="closeModal" @touchstart.stop>
        <div
          role="dialog"
          aria-modal="true"
          :aria-label="modalLabel"
          class="bg-foreground box-shadow-static-lg px-16 pb-16 w-full rounded-t-xl bottom-0 fixed overflow-auto max-h-[85vh]"
          :class="mobileFiltersOnLargerScreens ? 'desktop-styles--dialog' : 'sm:static sm:m-auto sm:rounded-xl'"
          @mousedown.stop
        >
          <div class="bg-foreground flex sticky top-0 py-16 z-[1]">
            <h2 class="text-h4 text-grey-header">{{ modalLabel }}</h2>
            <button class="modal-close ml-auto" aria-label="Close" @click="closeModal">
              <IconClose />
            </button>
          </div>
          <slot :closeModal="closeModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Caret from '../../icons/Caret.vue';
import IconClose from '../../icons/IconClose.vue';

export default {
  name: 'SearchFilterToken',
  components: {
    Caret,
    IconClose,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
    modalLabel: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    // added to fix styling issues with job search filter bar
    mobileFiltersOnLargerScreens: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonClasses: {
      type: String,
      default: '',
      required: false,
    },
  },
  data(): any {
    return {
      buttonToggled: false,
    };
  },
  computed: {
    selectedClass(): string {
      return this.buttonToggled || this.selected ? ' selected' : '';
    },
    iconDirection(): string {
      return this.buttonToggled ? 'rotate-180' : '';
    },
  },
  mounted() {
    document.addEventListener(
      'click',
      ({ target }) => {
        if (
          (target as HTMLElement)?.id !== `${this.modalLabel}-filter-token-button` &&
          (target as HTMLElement)?.className.includes('filter-token-button')
        ) {
          this.buttonToggled = false;
        }
        if ((target as HTMLElement).closest('.filter-token') !== null) return;
        this.buttonToggled = false;
      },
      false
    );
  },
  methods: {
    buttonHandler(): void {
      this.buttonToggled = !this.buttonToggled;
    },
    closeModal(e) {
      if (e) {
        e.preventDefault();
      }
      this.buttonToggled = false;
      this.$emit('close');
      document.documentElement.classList.remove('overflow-hidden', 'overflow-hidden:sm');
    },
  },
};
</script>

<style>
/* fix for cookie banner + support button overlap with filter token popups */
@media only screen and (max-width: 870px) {
  main:has(#filter-token-component) ~ #onetrust-consent-sdk #ot-sdk-btn-floating,
  main:has(#filter-token-component) ~ div:has(iframe#launcher) iframe#launcher {
    z-index: 1 !important;
  }
}
</style>
<style lang="scss" scoped>
.filter-token {
  .filter-token-button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    color: theme('colors.grey.clickable');
    font-weight: theme('fontWeight.medium');
    outline: none;
    transition: all 250ms ease-out;
    padding: 8px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      border: theme('borderWidth.1') solid theme('colors.grey.clickable');
      border-radius: theme('borderRadius.md');
      height: 100%;
      width: 100%;
      pointer-events: none;
    }

    &:hover,
    &:focus-visible {
      color: theme('colors.brand.contrast');
      transition: all 100ms ease-out;
      &::before {
        content: '';
        border-color: theme('colors.brand.contrast');
      }
    }

    &:focus-visible::after {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border: 2px dotted theme('colors.brand.contrast');
      margin: -4px;
      border-radius: 4px;
      outline: none;
      pointer-events: none;
    }

    &.selected {
      color: theme('colors.primary.DEFAULT');
      background: theme('colors.primary.subdued');
      transition: all 100ms ease-out;
      &::before {
        content: '';
        border: 2px solid theme('colors.primary.DEFAULT');
      }
    }
  }
  .text-field-input {
    speak-as: spell-out;
  }
  .filter-token-modal {
    .modal-wrapper {
      display: inline-block;
      width: 100%;
    }
  }
  .desktop-styles {
    &--container {
      background-color: rgba(0, 0, 0, 0.5);
      @media only screen and (min-width: 870px) {
        background: none;
        display: inline-block;
        position: absolute;
        --tw-bg-opacity: 0;
        top: calc(100% + 12px);
        width: 368px;
        height: auto;
        margin: 0;
      }
    }
    &--dialog {
      @media only screen and (min-width: 870px) {
        position: static;
        margin: auto;
        border-radius: 4px;
      }
    }
  }
}
</style>
